import { useCallback, useState } from 'react';

const ASIDE_KEY = 'winnerSelection.asideWidth';
const ASIDE_COLLAPSED_KEY = 'winnerSelection.asideCollapsed';
export const ASIDE_DEFAULT = 296;
export const ASIDE_MIN = 240;
export const ASIDE_MAX = 440;

interface IAsideState {
    width: number;
    setWidth: (w: number) => void;
    collapsed: boolean;
    toggleCollapsed: () => void;
}

/**
 * Хук персистит ширину aside и collapsed-флаг в localStorage.
 * При невалидном/отсутствующем значении — fallback на ASIDE_DEFAULT / false.
 */
export function useAsidePersistence(): IAsideState {
    const [width, setWidthRaw] = useState<number>(() => {
        try {
            const stored = localStorage.getItem(ASIDE_KEY);
            const n = stored ? Number(stored) : NaN;
            return Number.isFinite(n) && n >= ASIDE_MIN && n <= ASIDE_MAX ? n : ASIDE_DEFAULT;
        } catch {
            return ASIDE_DEFAULT;
        }
    });
    const [collapsed, setCollapsed] = useState<boolean>(() => {
        try {
            return localStorage.getItem(ASIDE_COLLAPSED_KEY) === '1';
        } catch {
            return false;
        }
    });

    const setWidth = useCallback((w: number) => {
        setWidthRaw(w);
        try {
            localStorage.setItem(ASIDE_KEY, String(Math.round(w)));
        } catch {
            /* ignore */
        }
    }, []);

    const toggleCollapsed = useCallback(() => {
        setCollapsed((prev) => {
            const next = !prev;
            try {
                localStorage.setItem(ASIDE_COLLAPSED_KEY, next ? '1' : '0');
            } catch {
                /* ignore */
            }
            return next;
        });
    }, []);

    return { width, setWidth, collapsed, toggleCollapsed };
}
